'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globals = require('../mixins/globals');

var _globals2 = _interopRequireDefault(_globals);

var _UiAlert = require('../material/UiAlert.vue');

var _UiAlert2 = _interopRequireDefault(_UiAlert);

var _UiIconButton = require('../material/UiIconButton.vue');

var _UiIconButton2 = _interopRequireDefault(_UiIconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ListarLocales',
  mixins: [_globals2.default],
  components: {
    UiAlert: _UiAlert2.default,
    UiIconButton: _UiIconButton2.default
  },
  data: function data() {
    return {
      locals: [],
      restaurants: [],
      error: {
        status: false,
        messages: ''
      },
      responseLocals: false,
      flagDelete: false,
      disabledCreate: false,
      disabledDelete: false,
      loadingDelete: false,
      typeItem: '',
      itemDelete: {
        name: '',
        id: 0
      }
    };
  },


  computed: {
    disabledCreate: function disabledCreate() {
      if (window.localStorage.getItem('role') === 'subgerente') {
        return true;
      } else {
        return false;
      }
    }
  },

  watch: {
    'error.status': function errorStatus(val, old) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.error.status = false;
        }, 1600);
      }
    }
  },

  created: function created() {
    this.fetchLocal();
    this.fetchRestaurant();
  },


  methods: {
    disablePermission: function disablePermission(restaurante_id) {
      if (window.localStorage.getItem('role') != 'subgerente') {
        if (window.localStorage.getItem('restaurante') == restaurante_id || window.localStorage.getItem('restaurante') == 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    opentDeleteModal: function opentDeleteModal(_item, _type) {
      this.flagDelete = !this.flagDelete;
      this.typeItem = _type;
      this.itemDelete.name = _item.name;
      this.itemDelete.id = _item.id;
    },
    getRestaurant: function getRestaurant(restaurante_id) {
      if (this.restaurants.length > 0) {
        var restaurante = this.restaurants.filter(function (val, key) {
          return val.id == restaurante_id;
        });
        return restaurante[0].name;
      }
    },
    onSubmitDelete: function onSubmitDelete() {
      var _this2 = this;

      var _url = '/admin/local/delete';

      this.disabledDelete = true;
      this.loadingDelete = true;
      var _temp = {
        id: this.itemDelete.id
      };
      this.$http.post(_url, _temp).then(function (response) {
        _this2.restoreItem(_this2.itemDelete.id, 'delete');
        _this2.disabledDelete = false;
        _this2.loadingDelete = false;
        _this2.flagDelete = !_this2.flagDelete;
      }, function (response) {
        _this2.disabledDelete = false;
        _this2.loadingDelete = false;
        _this2.flagDelete = !_this2.flagDelete;
      });
    },
    onSubmitRestore: function onSubmitRestore() {
      var _this3 = this;

      var _url = '/admin/local/restore';

      this.disabledDelete = true;
      this.loadingDelete = true;
      var _temp = {
        id: this.itemDelete.id
      };
      this.$http.post(_url, _temp).then(function (response) {
        _this3.restoreItem(_this3.itemDelete.id);
        _this3.disabledDelete = false;
        _this3.loadingDelete = false;
        _this3.flagDelete = !_this3.flagDelete;
      }, function (response) {
        _this3.disabledDelete = false;
        _this3.loadingDelete = false;
        _this3.flagDelete = !_this3.flagDelete;
      });
    },
    fetchLocal: function fetchLocal() {
      var _this4 = this;

      var _url = '/admin/local';

      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _this4.locals = _data;
        // let _data = response.data
        _this4.$nextTick(function () {
          _this4.responseLocals = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this4.$router.go({
            name: 'sign'
          });
        }
      });
    },
    restoreItem: function restoreItem(_uid) {
      var _type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'restore';

      var _p = this.locals;
      _p.forEach(function (val) {
        if (val.id === _uid) {
          if (_type === 'delete') {
            val.deleted_at = 'restore';
          } else {
            val.deleted_at = null;
          }
          return;
        }
      });
    },
    fetchRestaurant: function fetchRestaurant() {
      var _this5 = this;

      var _url = '/admin/restaurant';

      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _this5.restaurants = _data;
        // let _data = response.data
        _this5.$nextTick(function () {
          _this5.responseUsers = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this5.person = response.data;
          _this5.$router.go({
            name: 'sign'
          });
        }
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"bgTransition\">\n  <template v-if=\"!responseLocals\">\n    <div class=\"preload-app\">\n      <ui-progress-linear :show=\"!responseLocals\" color=\"black\"></ui-progress-linear>\n    </div>\n  </template>\n  <template v-else=\"\">\n    <div class=\"header-section h_contact\">\n      <h2 v-if=\"titleShow\" transition=\"slideLeft\">Lista de Locales</h2>\n      <div v-if=\"titleShow\" transition=\"slideRight\" class=\"buttons-options\">\n        <ui-button color=\"lanacional-white\" raised=\"\" @click=\"backToUrl('local-crear')\" :disabled=\"disabledCreate\">Crear Local</ui-button>\n      </div>\n    </div>\n\n    <section class=\"section-users\">\n      <template v-if=\"locals.length == 0\">\n        <ui-alert :dismissible=\"false\">No hay locales registrados.</ui-alert>\n      </template>\n      <template v-else=\"\">\n        <div class=\"width-users bg-white clearfix table-responsive\" style=\"padding: 15px;\">\n          <table class=\"table table-striped table-bordered\" style=\"margin: 0\">\n            <thead>\n              <tr>\n                <th>Nombres</th>\n                <th>Dirección</th>\n                <th>Restaurante</th>\n                <th style=\"width: 82px;\">Opciones</th>\n              </tr>\n            </thead>\n            <tbody>\n              <template v-for=\"item of locals\">\n                <tr>\n                  <td>{{item.name}}</td>\n                  <td>{{item.address}}</td>\n                  <td>{{getRestaurant(item.restaurante_id)}}</td>\n                  <td v-if=\"isDataNull(item.deleted_at)\">\n                    <ui-icon-button @click=\"backToUrl('local-editar', item.id+'')\" type=\"flat\" icon=\"edit\" color=\"lanacional-primario-text\" :disabled=\"disablePermission(item.restaurante_id)\"></ui-icon-button>\n                    <ui-icon-button @click=\"opentDeleteModal(item,'delete')\" type=\"flat\" icon=\"delete\" color=\"lanacional-cuarto-text\" :disabled=\"disablePermission(item.restaurante_id)\"></ui-icon-button>\n                  </td>\n                  <td v-if=\"!isDataNull(item.deleted_at)\" class=\"td-restore\">\n                    <ui-icon-button @click=\"opentDeleteModal(item, 'restore')\" type=\"flat\" icon=\"restore\" color=\"lanacional-primario-text\" :disabled=\"disablePermission(item.restaurante_id)\"></ui-icon-button>\n                  </td>\n                </tr>\n              </template>\n            </tbody>\n          </table>\n        </div>\n      </template>\n    </section>\n\n    <div class=\"modal-mask\" v-if=\"flagDelete\" transition=\"modal\">\n      <div class=\"modal-wrapper\">\n        <div class=\"modal-container\">\n          <div class=\"modal-header\">\n            <h4 class=\"modal-title\">{{typeItem=='delete' ?'Deshabilitar Local':'Habilitar Local'}} </h4>\n          </div>\n          <div class=\"modal-body text-center\">\n            <p style=\"margin:0;\">¿Estas seguro que deseas {{typeItem=='delete' ?'deshabilitar':'habilitar'}} a <b>{{itemDelete.name}}</b>?</p>\n          </div>\n          <div class=\"modal-footer\">\n            <div class=\"text-center\">\n              <ul class=\"nav nav_menu_form\">\n                <li>\n                  <ui-button @click=\"flagDelete = !flagDelete\" text=\"Cancel\" color=\"lanacional-primario\" :disabled=\"disabledDelete\"></ui-button>\n                </li>\n                <li>\n                  <template v-if=\"typeItem=='delete'\">\n                    <ui-button @click=\"onSubmitDelete()\" text=\"Deshabilitar\" color=\"lanacional-cuarto\" :loading=\"loadingDelete\"></ui-button>\n                  </template>\n                  <template v-else=\"\">\n                    <ui-button @click=\"onSubmitRestore()\" text=\"Habilitar\" color=\"lanacional-cuarto\" :loading=\"loadingDelete\"></ui-button>\n                  </template>\n                </li>\n              </ul>\n            </div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-4a98f55d", module.exports)
  } else {
    hotAPI.update("_v-4a98f55d", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}